import { IImageObject } from "../../../../../domain/editableFormat/objects";
import { IImageObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import { ImageDrawableObjectTranslator } from "./base";

export class ImageObjectTranslator extends AbstractObjectTranslator<IImageObject, IImageObjectBean> {
  constructor() {
    super(new ImageDrawableObjectTranslator());
  }

  protected shouldRecordName(source: IImageObjectBean): boolean {
    return true;
  }

  overwriteObject(source: IImageObject, bean: IImageObjectBean, formatId: number): void {
    source.isBackground = (bean["@bg"] === "1");
    source.editingOnly = (bean["@hide"] === "1");
  }

  overwriteBean(source: IImageObjectBean, object: IImageObject): void {
    source["@edit"] = "1";
    source["@bg"] = object.isBackground ? "1" : undefined;  // 背景(下地)(1)はobjectとしては扱わない.レイヤー(描画)(2)はフォーマット編集では扱わない.
    source["@hide"] = object.editingOnly ? "1" : undefined;
  }
}
